import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Sidney',
    reviewText:
      'I need simplicity and Zola made my wedding planning super easy! From the cute website layouts to the ease of making a registry, I am very happy wit...',
    title: 'So easy and fun',
  },
  {
    name: 'Jaz',
    reviewText:
      'Zola made it so easy to plan our wedding. The planning checklists were incredibly helpful, and their free website and registry services were easy t...',
    title: 'Thank you Zola!!!',
  },
  {
    name: 'Em',
    reviewText:
      'This website has taken the burden out of wedding planning! I love how it coordinates with the app as well...',
    title: 'The best',
  },
];
